/** Editable copy — creator Thspian subscription upsell on campaign detail payout panel. */
export const CREATOR_PAYOUT_SUBSCRIBE_UPSELL_COPY = {
    viewPlansButtonLabel: 'View subscription plans',
    /**
     * Modal intro when opened from campaign payout. Placeholders:
     * - `{{saveAmount}}` — formatted USD saved per campaign (e.g. "$30.00")
     */
    modalPromptTemplate: 'Subscribe to keep {{saveAmount}} more on campaigns like this. Choose a plan below.',
    modalPromptFallback: 'Subscribe to keep more of your campaign earnings. Choose a plan below.',
    /**
     * Unsubscribed payout panel. Placeholders:
     * - `{{saveAmount}}`, `{{subscribedNet}}`, `{{unsubscribedNet}}`
     */
    upsellLineTemplate:
        'Subscribe to keep {{saveAmount}} more on this campaign ({{subscribedNet}} net vs {{unsubscribedNet}}).',
    /**
     * Subscribed payout panel. Placeholders:
     * - `{{extraAmount}}` — formatted USD more than non-subscribers (e.g. "$12.00")
     */
    subscribedBenefitTemplate:
        'Your subscription earns you {{extraAmount}} more on this campaign than creators without a plan.',
} as const;

export function formatCreatorPayoutSubscribeModalPrompt(saveAmountFormatted?: string | null): string {
    if (saveAmountFormatted) {
        return CREATOR_PAYOUT_SUBSCRIBE_UPSELL_COPY.modalPromptTemplate.replace('{{saveAmount}}', saveAmountFormatted);
    }
    return CREATOR_PAYOUT_SUBSCRIBE_UPSELL_COPY.modalPromptFallback;
}

export function formatCreatorPayoutUpsellLine(
    saveAmountFormatted: string,
    subscribedNetFormatted: string,
    unsubscribedNetFormatted: string,
): string {
    return CREATOR_PAYOUT_SUBSCRIBE_UPSELL_COPY.upsellLineTemplate
        .replace('{{saveAmount}}', saveAmountFormatted)
        .replace('{{subscribedNet}}', subscribedNetFormatted)
        .replace('{{unsubscribedNet}}', unsubscribedNetFormatted);
}

export function formatCreatorPayoutSubscribedBenefit(extraAmountFormatted: string): string {
    return CREATOR_PAYOUT_SUBSCRIBE_UPSELL_COPY.subscribedBenefitTemplate.replace(
        '{{extraAmount}}',
        extraAmountFormatted,
    );
}
